const TornadoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 13.5 16.5"
    fill="none"
    {...props}
  >
    <path
      d="M9 16.5H6V15H9V16.5ZM7.5 13.5H3V12H7.5V13.5ZM7.5 10.5H0V9H7.5V10.5ZM9 7.5H0V6H9V7.5ZM12 4.5H1.5V3H12V4.5ZM13.5 0V1.5H0V0H13.5Z"
      fill="currentColor"
    />
  </svg>
);

export default TornadoIcon;
